import React, { useRef } from 'react';
import { Modal, ModalSize, ModalType } from '@ukpostbox/frontend-framework';
import SendsHistoryControl from '../Controls/SendsHistoryControl';

interface PageHistoryModalType extends ModalType {
	pageId: number;
}

function PageHistoryModal(props: PageHistoryModalType) {
	const sendsHistoryRef = useRef<any>(null);

	return (
		<Modal
			title='Page History'
			isOpen={props.isOpen}
			closeCallback={() => props.closeCallback()}
			modalSize={ModalSize.Large}
		>
			<SendsHistoryControl containerRef={sendsHistoryRef} hideHeader />
		</Modal>
	);
}

export default PageHistoryModal;
